type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
  sparkleColor?: string;
};

/**
 * A speaker (SpeakersIcon's head + shoulders, nudged left) with the AI
 * sparkle (SparkleIcon's glyph) at its top-right — "identify speakers with AI".
 */
const AiSpeakerIcon = (props: Props) => {
  const {
    width = '20',
    height = '20',
    strokeColor = 'currentColor',
    sparkleColor = 'var(--primary)',
  } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M7 7.5C8.24 7.5 9.25 6.49 9.25 5.25C9.25 4.01 8.24 3 7 3C5.76 3 4.75 4.01 4.75 5.25C4.75 6.49 5.76 7.5 7 7.5Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 14C11.5 11.51 9.49 9.5 7 9.5C4.51 9.5 2.5 11.51 2.5 14"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g transform="translate(10.2 0.6) scale(0.56)">
        <path
          d="m5.00586.50293.00684.020508.04101.180664c.49416 2.202648 2.24242 3.894968 4.44238 4.284178h.00196c.00073.00316.00195.00706.00195.01172 0 .00421-.00133.00774-.00195.01074l-.00196.00098c-2.19996.38921-3.94822 2.08153-4.44238 4.28418l-.04101.18066c-.00315.01399-.00636.01976-.00684.02051l-.01563.00293c-.009-.00006-.01419-.00217-.01562-.00293l-.00684-.02051-.0332-.15527c-.47666-2.21408-2.22545-3.92198-4.432617-4.3125l-.000976-.00098c-.000348-.00231-.000977-.0049-.000977-.00781 0-.00332.000543-.00626.000977-.00879h.000976c2.207167-.39053 3.955957-2.09843 4.432617-4.312499l.0332-.155273c.00307-.014039.00644-.019882.00684-.020508l.01562-.00293c.00894-.00004.01413.002163.01563.00293z"
          fill={sparkleColor}
          stroke={sparkleColor}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default AiSpeakerIcon;
